import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ModalWindowComponent } from '../modal-window/modal-window.component';
import { pgiAuthors } from 'src/app/models/authors';
import { FileUploader } from 'ng2-file-upload';

const URL = 'http://localhost:aaaaaaaaaaaa';

@Component({
  selector: 'app-add-note-author',
  templateUrl: './add-note-author.component.html',
  styleUrls: ['./add-note-author.component.css']
})
export class AddNoteAuthorComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ModalWindowComponent>,

    @Inject(MAT_DIALOG_DATA) public data: pgiAuthors) { }

    public uploader: FileUploader = new FileUploader({ url: URL, itemAlias: '' });

  ngOnInit() {
    this.uploader.onAfterAddingFile = (file) => { file.withCredentials = false; };
    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
         console.log('ImageUpload:uploaded:', item, status, response);
         alert('File uploaded successfully');
     };
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
